import React from 'react'
import { Card, CardBody, CardHeader, CardTitle, Col, Row } from 'reactstrap'
import { PlayCircle } from "phosphor-react"
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { processError } from '../../lib/lib'
import api from '../../api/api'
import okko from '../../assets/img/platforms/okko.png'
import ivi from '../../assets/img/platforms/ivi.png'
import kinopoisk from '../../assets/img/platforms/kinopoisk.png'
import netflix from '../../assets/img/platforms/netflix.png'
import youtube from '../../assets/img/platforms/youtube.png'
import Cookies from 'universal-cookie'
import Skeleton from '../../components/UI/Skeleton'
const cookies = new Cookies()

class FilmDesc extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            film: {
                title: '',
                image: '',
                desc: '',
                platformIvi: '',
                platformKinopoisk: '',
                platformNetflix: '',
                platformOkko: '',
                platformYoutube: '',
            },
            filmLoaded: false,
            imageLoaded: false,
            dataLoaded: false,
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
        }
    }

    getFilmInfo(id, token, lang) {
        return new Promise((resolve, reject) => {
            api.getFilmInfo(id, token, lang)
                .then((res) => resolve(res))
                .catch((e) => {
                    processError(e, this.props.history)
                    reject(e)
                })
        })
    }

    async componentWillMount() {
        const accessToken = cookies.get('accessToken')
        let arrPromise = [
            this.getFilmInfo(this.props.match.params.filmId, accessToken, this.props.i18n.language).then((film) => this.setState({ filmLoaded: true, film })),
        ]
        Promise.all(arrPromise).then(() => this.setState({ dataLoaded: true }))
    }

    render() {
        const { t } = this.props
        return (
            <Row className="film w-100 m-0">
                <Col xs={12}>
                    {
                        this.state.filmLoaded ?
                            <div className="page-title md-font-size">
                                <span className="link" onClick={() => this.props.history.push('/cinema')}>{t('cinema-cinema')}</span>
                                <span className="title"> / {this.state.film.title}</span>
                            </div>
                            :
                            <div className="page-title md-font-size">
                                <span className="link">{t('cinema-cinema')}</span>
                                <span className="title"> / <Skeleton width={'20%'} /></span>
                            </div>
                    }
                </Col>
                <Col xl={9} lg={12}>
                    <div className="film card">
                        {
                            this.state.filmLoaded ?
                                <div className="play-img">
                                    {!this.state.imageLoaded && this.state.film.image && <Skeleton className="card-img" image={true} height={400} />}
                                    {this.state.film.image && <img onLoad={() => this.setState({ imageLoaded: true })} src={`${this.state.imageUrl}/${this.state.film.image}`} alt="" className={`card-img${this.state.imageLoaded ? '' : ' d-none'}`} />}
                                    <PlayCircle size={100} color="#ffffff" weight="fill" className="play-btn" />
                                </div>
                                :
                                <div className="play-img">
                                    <Skeleton className="card-img" image={true} height={400} />
                                </div>
                        }
                        {
                            this.state.filmLoaded ?
                                <div className="card-body">
                                    <div className="card-title xl-font-size">{this.state.film.title}</div>
                                    <div className="card-desc md-font-size" dangerouslySetInnerHTML={{ __html: this.state.film.desc }}></div>
                                    <div className="card-platforms"></div>
                                </div>
                                :
                                <div className="card-body">
                                    <div className="card-title xl-font-size"><Skeleton width={'50%'} /></div>
                                    <div className="card-desc md-font-size"><Skeleton count={5} /></div>
                                    <div className="card-platforms"></div>
                                </div>
                        }
                    </div>
                </Col>
                <Col xl={3} lg={12}>
                    <Card className="platform-card">
                        <CardHeader>
                            <CardTitle className="title lg-font-size">{t('cinema-where-to-watch')}</CardTitle>
                        </CardHeader>
                        {
                            this.state.filmLoaded ?
                                <CardBody>
                                    {
                                        this.state.film.platformOkko &&
                                        <div className="platform-item okko" onClick={() => window.open(this.state.film.platformOkko, '_blank')}>
                                            <PlayCircle size={50} weight="fill" className="icon" />
                                            <img src={okko} className="logo" alt="" />
                                        </div>
                                    }
                                    {
                                        this.state.film.platformIvi &&
                                        <div className="platform-item ivi" onClick={() => window.open(this.state.film.platformIvi, '_blank')}>
                                            <PlayCircle size={50} weight="fill" className="icon" />
                                            <img src={ivi} className="logo" alt="" />
                                        </div>
                                    }
                                    {
                                        this.state.film.platformKinopoisk &&
                                        <div className="platform-item kinopoisk" onClick={() => window.open(this.state.film.platformKinopoisk, '_blank')}>
                                            <PlayCircle size={50} weight="fill" className="icon" />
                                            <img src={kinopoisk} className="logo" alt="" />
                                        </div>
                                    }
                                    {
                                        this.state.film.platformYoutube &&
                                        <div className="platform-item youtube" onClick={() => window.open(this.state.film.platformYoutube, '_blank')}>
                                            <PlayCircle size={50} weight="fill" className="icon" />
                                            <img src={youtube} className="logo" alt="" />
                                        </div>
                                    }
                                    {
                                        this.state.film.platformNetflix &&
                                        <div className="platform-item netflix" onClick={() => window.open(this.state.film.platformNetflix, '_blank')}>
                                            <PlayCircle size={50} weight="fill" className="icon" />
                                            <img src={netflix} className="logo" alt="" />
                                        </div>
                                    }
                                </CardBody>
                                :
                                <CardBody>
                                    <Skeleton className="my-2" height={35} count={3} />
                                </CardBody>
                        }
                    </Card>
                </Col>
            </Row>
        )
    }
}

FilmDesc.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
}

export default withTranslation()(FilmDesc)



// WEBPACK FOOTER //
// ./src/views/Cinema/FilmDesc.jsx